import React from 'react';
import { Language } from '../App';
interface CherryButtonProps {
  language: Language;
}
const content = {
  en: 'Apply for Financing',
  es: 'Solicitar Financiamiento'
};
export function CherryButton({
  language
}: CherryButtonProps) {
  return <a href="https://patient.withcherry.com/pearl-ann-t-brown-md-pllc" target="_blank" rel="noopener noreferrer" style={{
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#7a6f9b',
    color: '#ffffff',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '16px',
    borderRadius: '50px',
    padding: '14px 24px',
    textDecoration: 'none',
    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  }} onMouseEnter={e => {
    e.currentTarget.style.backgroundColor = '#6a5f8a';
    e.currentTarget.style.transform = 'scale(1.05)';
  }} onMouseLeave={e => {
    e.currentTarget.style.backgroundColor = '#7a6f9b';
    e.currentTarget.style.transform = 'scale(1)';
  }} data-id="element-25">
      <span data-id="element-26">💳</span>
      <span data-id="element-27">{content[language]}</span>
    </a>;
}